import { MarketplaceInfo } from '../api/v1-api/helpers';

/**
 * Returns the appropriate domain based on the marketplace type
 * @param marketplace The marketplace object
 * @returns The domain string (withloma.com or loma.tech)
 */
export const getMarketplaceDomain = (marketplace?: MarketplaceInfo | null): string => {
  return marketplace?.withloma ? 'withloma.com' : 'loma.tech';
};

export const getMarketplaceLink = (marketplace: MarketplaceInfo) => {
  if (marketplace.domain && marketplace.domain.status === 'active') {
    return `https://${marketplace.domain.domain}/`;
  }
  if (process.env.NODE_ENV === 'development') {
    return `http://${marketplace.slug}.localhost:3030/`;
  }
  const marketplaceDomain = getMarketplaceDomain(marketplace);
  if (process.env.NEXT_PUBLIC_ENV === 'staging') {
    return `https://${marketplace.slug}.staging.${marketplaceDomain}/`;
  }
  return `https://${marketplace.slug}.${marketplaceDomain}/`;
};
